import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import showCcWell from './showCcWell';
import datapoints from '../datapoints';
import { findComposePlugins } from '../plugins/ComposePlugins';
import convertInlineCssForHtml from '../utils/convertInlineCssForHtml';
import createAppendOnSendBlock from '../utils/createAppendOnSendBlock';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import getFromViewState from '../utils/getFromViewState';
import shouldAlwaysShowFrom from '../utils/shouldAlwaysShowFrom';
import isGroupComposeViewState from 'owa-mail-compose-store/lib/utils/isGroupComposeViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { getBottomDockingHeight, updateDockingHeight } from 'owa-editor-docking-plugin';
import initializeUndoSnapshot from 'owa-editor/lib/actions/initializeUndoSnapshot';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { ComposeViewState } from 'owa-mail-compose-store';

export default createLegacyActionWithDatapoint('upConvert', datapoints.MailComposeUpConvert)(
    function upConvert(viewState: ComposeViewState) {
        if (viewState.bodyType == 'HTML') {
            viewState.isRibbonShown = true;
        }

        // Clear existing undo snapshots by reinitialize
        initializeUndoSnapshot(viewState);

        const plugins = findComposePlugins(viewState);
        if (plugins) {
            const contentOperationPlugin = plugins.contentOperation;
            if (contentOperationPlugin) {
                contentOperationPlugin.updateContentToViewState();
                contentOperationPlugin.stopSaveOnDispose();
            }
        }

        if (viewState.quotedBody) {
            // Clean global CSS and convert to inline CSS if any, so that global CSS will not impact new content
            const quotedBody = convertInlineCssForHtml(viewState.quotedBody, viewState.bodyType);
            viewState.content =
                viewState.content + createAppendOnSendBlock(viewState.bodyType) + quotedBody;
            viewState.useSmartResponse = false;
        } else if (isGroupComposeViewState(viewState) && viewState.lastSavedMessageBody) {
            viewState.content = convertInlineCssForHtml(
                viewState.lastSavedMessageBody,
                viewState.bodyType
            );
            viewState.useSmartResponse = false;
        } else {
            addInfoBarMessage(viewState, 'warningNoQuotedBody');
        }

        viewState.isInlineCompose = false;

        if (shouldAlwaysShowFrom()) {
            // When upconverting from inline compose, we need to re-initialize the from well view state.
            // This is because certain properties remain unset on purpose (to try to minimize when the well is visible unexpectedly)
            viewState.fromViewState = getFromViewState(
                viewState.fromViewState.from ? viewState.fromViewState.from.email : null,
                viewState.meetingRequestItem,
                viewState.referenceItemId,
                isPublicFolderComposeViewState(viewState),
                viewState.fromViewState.isFromShown
            );
        }

        if (!isConsumer()) {
            showCcWell(viewState);
        }

        updateDockingHeight(
            viewState.docking,
            getBottomDockingHeight(viewState.isRibbonShown, viewState.isInlineCompose)
        );
    }
);
